import { IrisStatus } from '../enums';
import { IrisConfig } from '../interfaces';

export const IrisStatusConfig = new Map<IrisStatus, IrisConfig>([
  [
    IrisStatus.PRE_RELEASE,
    {
      status: 'preRelease',
      statusColor: '#00AEEF',
      iconClass: 'alc-horn-trumpet-icon',
    },
  ],
  [
    IrisStatus.ACTIVE,
    {
      status: 'active',
      statusColor: '#00AE44',
    },
  ],
  [
    IrisStatus.RUN_DOWN,
    {
      status: 'runDown',
      statusColor: '#FF6B12',
      iconClass: 'alc-download-arrow-circle-icon',
    },
  ],
  [
    IrisStatus.USE_UP,
    {
      status: 'useUp',
      statusColor: '#FF6B12',
      iconClass: 'alc-download-arrow-circle-icon',
    },
  ],
  [
    IrisStatus.QUALITY_HOLD,
    {
      status: 'qualityHold',
      statusColor: '#FF6B12',
      iconClass: 'alc-download-arrow-circle-icon',
    },
  ],
  [
    IrisStatus.RETURNS_REBATE,
    {
      status: 'returnsRebate',
      statusColor: '#9B1A2F',
      iconClass: 'alc-warning-error-icon',
    },
  ],
  [
    IrisStatus.INACTIVE,
    {
      status: 'inactive',
      statusColor: '#9B1A2F',
      iconClass: 'alc-warning-error-icon',
    },
  ],
]);

export const unknownIrisStatusConfig = {
  status: 'unavailable',
  statusColor: '#9B1A2F',
  iconClass: 'alc-warning-error-icon',
};

export const errorPartIrisStatusCodes = new Set([IrisStatus.INACTIVE, IrisStatus.RETURNS_REBATE]);
